var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwittericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73357 13.6667C7.22307 13.75 9.64046 12.823 11.436 11.0965C13.2315 9.37008 14.2525 6.99089 14.2669 4.50003C14.8316 3.80121 15.2509 2.99655 15.5002 2.13336C15.5382 1.99405 15.491 1.8454 15.3794 1.75367C15.2679 1.66193 15.1129 1.64419 14.9836 1.70836C14.3778 1.99997 13.6535 1.87254 13.1836 1.39169C12.5925 0.744472 11.7646 0.364164 10.8885 0.337473C10.0125 0.310783 9.16291 0.639985 8.53357 1.25003C7.66604 2.09019 7.30235 3.32359 7.57524 4.50003C4.78357 4.6667 2.8669 3.3417 1.33357 1.52503C1.23944 1.41844 1.09119 1.37759 0.955757 1.42093C0.82032 1.46427 0.723326 1.58359 0.708569 1.72503C0.110333 5.0435 1.63929 8.38394 4.5419 10.1C3.5916 11.1899 2.25708 11.8706 0.816903 12C0.658719 12.0263 0.534716 12.1502 0.508356 12.3083C0.481996 12.4665 0.559111 12.6239 0.700236 12.7C1.95317 13.3262 3.33293 13.6569 4.73357 13.6667",
    fill: "#00AAEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericon);
export default __webpack_public_path__ + "static/media/twittericon.7dc566e8a19b39271836a1b5fe3edf09.svg";
export { ForwardRef as ReactComponent };